export default "__VITE_ASSET__B8Z3Brlz__"